class StoreList extends window.BAO.CustomElement() {
  static get requiredEls () {
    return ['filter', 'store']
  }

  setupListeners () {
    if (this.els?.filter?.exists === true) {
      this.els.filter.elements.forEach(element => {
        element.addEventListener('click', () => {
          this.filter = element.dataset.filter
        })
      })
    }
  }

  get filter () {
    return this._filter
  }

  set filter (value) {
    this.els.filter.elements.forEach(filter => {
      filter.ariaSelected = filter.dataset.filter === value
    })

    if (value === '') {
      this.els.store.elements.forEach(store => {
        store.ariaHidden = false
      })
    } else {
      this.els.store.elements.forEach(store => {
        store.ariaHidden = store.dataset.filter !== value
      })
    }

    this._filter = value
  }
}

if (!customElements.get('store-list')) {
  customElements.define('store-list', StoreList)
}
